import React, { useState } from "react";
import categoryInfo from "../../categoryInfo.json";
import SectionLandingLikePublications from "../common/SectionLandingLikePublications";

export default function FinancialStability() {
  const [post] = useState(() => categoryInfo.financialstability ?? []);

  const lead = (
    <>
      <p>
        Fostering Financial Stability is a mandate of the National Bank of Rwanda. The bank achieves this
        objective through regularly monitoring performance of the financial system (i.e. the banking system,
        insurance sector, the pension, microfinance institutions, non-deposit taking financial institutions and
        the payment system) and adopting appropriate policy measures. Financial Stability Reports (FSR) are among
        key financial sector policy guiding analytical tools.
      </p>
      <p>Browse the topics in this section below.</p>
    </>
  );

  return (
    <SectionLandingLikePublications
      breadcrumbCurrent="Financial Stability"
      headingId="financial-stability-bnr-heading"
      pageTitle="Financial Stability"
      tagline="Monitoring and safeguarding Rwanda’s financial system"
      sharePageTitle="Financial Stability — National Bank of Rwanda"
      lead={lead}
      posts={post}
      pageFeedbackPath="/financialstability"
    />
  );
}
